// extracted by mini-css-extract-plugin
export default {"mapWrapper":"Map_mapWrapper__vN0Wq","popup":"Map_popup__4MuMB","popupInfo":"Map_popupInfo__Uy40k","companyName":"Map_companyName__GE1br","marker":"Map_marker__sTdUm"};